import { observer } from "mobx-react-lite"
import { baseUrl } from '../../api/api'
import { useStore } from "../../contexts/store"
import Overlay from "../Pdf/Overlay"

import { PodClass } from "../../classes/Pod"

import { Box } from "@mui/material"


const Thumbnail = ({height, nodeId, pageNumber, width}: {height: number, nodeId: string, pageNumber: number, width?: number}) => {
  const { podStore } = useStore()
  const pod: PodClass | null = podStore.pod
  if(pod === null) return null

  // get page object from pod
  const page = pod.getPdfPage(nodeId, pageNumber)
  // anchor for overlay
  const pageId = `${baseUrl}/pdf/${nodeId}-thumb-${pageNumber}`
  // image source
  const thumbnailUrl = `${baseUrl}/pageView/${nodeId}/${pageNumber}`

  return (
    <Box sx={{position: "relative", width: width ? `${width}px` : 'inherit'}} id={pageId}>
      <Box>
        <img
          alt={`Preview thumbnail for pdf page ${pageNumber}`}
          aria-label={`Preview thumbnail for pdf page ${pageNumber}`}
          src={thumbnailUrl}
          height={height}
        />
        {/* show overlay only if the scaling can be calculated */}
        {(page !== null && page.height !== null) &&
          <Overlay
            childrenDepth={0}
            pageId={pageId}
            pdfId={nodeId}
            pageNumber={pageNumber}
            scale={height/page.height}
          />
        }
      </Box>
    </Box>
  )
}

export default observer(Thumbnail)